
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { stockDTO } from 'src/app/model/stockDTO';
import { ColorProductoDTO } from 'src/app/model/colorProductoDTO';
import { Cliente } from 'src/app/model/cliente';
import { ProductoRelacionadoDTO } from 'src/app/model/productoRelacionadoDTO';
import { DummyJsonResponse, ProductsPaginator } from 'src/app/model/productoPaginator';
import { CodigoDescuento } from 'src/app/model/codigoDescuento';



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class ProductoDTOService {
    // private http2 = inject(HttpClient)

    private url : string = `${environment.HOST}/api/consulta`;
    private url2 : string = `${environment.HOST}/api/consulta-color-producto/`;

    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

      
 // getProductosDTO() {
   // return this.http.get<ProductosDTO>(`${this.url}/productodto`);
  //}

 getProductosDTO2(idCategoria:number):Observable<ProductosDTO[]>{
    return this.http.get<ProductosDTO[]>(`${this.url}/productosdto/by-categoria/${idCategoria}`);
 }

 getProductosDTOById(idProducto:number):Observable<ProductosDTO[]>{
  return this.http.get<ProductosDTO[]>(`${this.url}/productosdto/${idProducto}`);
}


getStockByProducto(idProducto:number):Observable<stockDTO[]>{
  return this.http.get<stockDTO[]>(`${this.url}/productosdto/stock/by-producto/${idProducto}`);
}




getProductosDTOByEstadoAndModelo(idEstado:number,modelo:string):Observable<ProductosDTO[]>{
  return this.http.get<ProductosDTO[]>(`${this.url}/estado-modelo/${idEstado}/${modelo}`);
}

getProductosDTOByDescripcion(idEstado:number,descripcion:string):Observable<ProductosDTO[]>{
  return this.http.get<ProductosDTO[]>(`${this.url}/producto-descripcion/${idEstado}/${descripcion.toUpperCase()}`);
}

getColorStockByProductos(idProducto:number):Observable<ColorProductoDTO[]>{
  return this.http.get<ColorProductoDTO[]>(`${this.url2}${idProducto}`)
 
}


getClienteByMovil(movil:String):Observable<Cliente[]>{
  return this.http.get<Cliente[]>(`${this.url}/movil-cliente/${movil}`);
  
}


getProductoRelacionadoByIdProducto(idProducto:number):Observable<ProductoRelacionadoDTO[]>{
  return this.http.get<ProductoRelacionadoDTO[]>(`${this.url}/producto-relacionado/${idProducto}`);
}

guardaStockTemporal( codigoErp : number,stock:number) {
  return this.http.post(`${this.url}/guarda-stock-temporal/${codigoErp}/${stock}`, "");
}

verificarLimiteExistencia( idUsuario : number,deallePedido:string) {
  return this.http.post(`${this.url}/verificar-limite-existencia/${idUsuario}/${deallePedido}`, "");
}

getCodigoDescuento( descripcion : String):Observable<CodigoDescuento[]> {
  return this.http.get<CodigoDescuento[]>(`${this.url}/codigo-descuento-by-descripcion/${descripcion}`);
}



getCodigoDescuentoAll( ):Observable<CodigoDescuento[]> {
  return this.http.get<CodigoDescuento[]>(`${this.url}/codigo-descuento-all`);
}



getProductosDTO3(page: number, size: number, order: string, asc: boolean,idCategoria:number):Observable<any>{
  return this.http.get<any>(this.url+ `/productosdto/by-categoria-pg/${idCategoria}?`+ `page=${page}&size=${size}&order=${order}&asc=${asc}`);
}


getProductosDTOByDescripcionPg(page: number, size: number, order: string, asc: boolean,idEstado:number,descripcion:string):Observable<any>{
  return this.http.get<any>(this.url+`/producto-descripcion-pg/${idEstado}/${descripcion.toUpperCase()}?`+ `page=${page}&size=${size}&order=${order}&asc=${asc}`);
}


// public get(page: number, size: number, order: string, asc: boolean): Observable<any> {
//   return this.httpClient.get<any>(this.paisesURL + `page=${page}&size=${size}&order=${order}&asc=${asc}`);
// }




// public getProducts$(idcategoria:number,page: number = 1, itemsPerPage: number = 5): Observable<ProductsPaginator> {
//   return this.http2.get<DummyJsonResponse>(
//     `${this.url}/productosdto/by-categoria-pg/${idcategoria}`,
//     {
//       params: {
//         limit: itemsPerPage,
//         skip: itemsPerPage * (page - 1)
//       }
//     }
//   ).pipe(
//     map((response) => ({
//       items: response.content,
//       page: page,
//       hasMorePages: 1 + response.size < response.totalElements
//     } as ProductsPaginator))
//   );
// }




    }